<template>
    <div class="body">
        <div class="bg"></div>
        <!-- <div class="popup" v-if="flag"></div> -->
        <div class="content">
            <div class="back" @click="$router.go(-1)">
                <img src="../../assets/img/i19.png" />
                返回
            </div>
            <div class="top">
                <div class="top_left">
                    <el-image class="t_left" :src="webImg + ktInfo.qrCode" :preview-src-list="[webImg + ktInfo.qrCode]"
                        v-if="ktInfo && ktInfo.qrCode"></el-image>
                    <div class="t_right">
                        <div class="tr_top">
                            <div class="trt_left">{{ ktInfo.courseName }}</div>
                            <div class="trt_right" @click="btn_analysis">
                                <img src="../../assets/img/i25.png" />
                                班级分析
                                <img src="../../assets/img/i26.png" />
                            </div>
                            <div class="trt_right" style="margin-left: 20px;" @click="flag4 = true, getCommentList()"
                                v-if="!ktInfo.isExperience">
                                <img src="../../assets/img/i68.png" />
                                课堂点评
                            </div>
                        </div>
                        <div class="tr_bottom">班级：{{ ktInfo.className }} <div></div> 学科：{{ ktInfo.subjectName }} <div></div> 课堂编码：{{ ktInfo.id }}</div>
                    </div>
                </div>
                <div class="top_right">
                    <div class="tr_btn2" @click="btn_pauseOrContinue" v-if="ktInfo.status == 0">
                        {{ ifPause == 0 ? '暂停使用' : '继续使用' }}
                    </div>
                    <div class="tr_btn1" @click="finishClassPop = true" v-if="ktInfo.status == 0">
                        结束上课
                    </div>
                    <div class="tr_btn" @click="btn_start" v-if="ktInfo.status == 2">
                        开始上课
                    </div>
                </div>
            </div>
            <div class="center">
                <div class="c_left">
                    <div class="cl_item" :class="tabIndex == index ? 'cll2' : ''" v-for="(item, index) in tabList"
                        :key="index" :title="item.helperName" @click="btn_tab(index)">
                        <img class="cli_icon" src="../../assets/img/i65.png" v-if="tabIndex == index" />
                        <img class="cli_left" :src="webImg + item.icon" />
                        <div class="cli_right">
                            <div class="lir_top line1_">{{ item.helperName }}</div>
                            <div class="lir_bottom" v-if="item.evaluateStatus == 0"
                                @click.stop="startAndEnd(item, item.status == 1 && (ktInfo.status == 0 || ktInfo.status == 2) && item.evaluateStatus == 0 ? 0 : 1, item.type)">
                                <img
                                    :src="item.status == 1 && (ktInfo.status == 0 || ktInfo.status == 2) && item.evaluateStatus == 0 ? require('../../assets/img/i66.png') : require('../../assets/img/i67.png')" />
                                {{ item.status == 1 && (ktInfo.status == 0 || ktInfo.status == 2) && item.evaluateStatus
                                    == 0 ? '未开启' : '已开启' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="b_left">
                    <div class="bl_item" :title="`${item.studentName} (No:${item.studentNo} )`"
                        v-for="(item, index) in stuList" :key="index" @click="btn_stu(item, index)">
                        <img class="border" src="../../assets/img/i64.png" v-if="item.score && item.score > 3" />
                        <div class="bli_label" :class="item.id ? '' : 'blil'">{{ item.evaluateStatus &&
                            item.evaluateStatus > 0 ? (item.evaluateStatus == 1 ? '分析中' : item.evaluateStatus == 2 ?
                                '分析成功' : '分析失败') : item.id ? '使用中' : '未使用' }}</div>
                        <img :class="item.score && item.score > 3 ? 'b1' : ''"
                            :src="webImg + item.avatar + '?x-oss-process=image/resize,m_fixed,w_100,h_100'" />
                        <div class="line1_">{{ item.studentName }} (No:{{ item.studentNo }} )</div>
                        <img class="pause" @click.stop="btn_stuPause(item, index)"
                            :src="item.ifPause == 0 || item.ifPause == null ? require('../../assets/img/i67.png') : require('../../assets/img/i66.png')" />
                    </div>
                </div>

                <div class="b_right">
                    <div class="br_tit ">
                        <div class="brt_tj" v-if="tabList[tabIndex] && tabList[tabIndex].type == 4"
                            @click="$router.push({ path: '/detailedStatistics', query: { id: helperId, questionGroupId: tabList[tabIndex].questionGroupId } })">
                            详情统计
                        </div>
                        <div class="brt_left">数据看板</div>
                        <div class="brt_right line1_" v-if="tabList[tabIndex]">({{
                            tabList[tabIndex].helperName }})</div>
                    </div>
                    <div class="br_box" id="oneChart"
                        v-if="chartInfo && chartInfo.indicator && chartInfo.indicator.length > 0 && tabList[tabIndex] && tabList[tabIndex].evaluate">
                    </div>
                    <!-- <el-empty description="暂无数据" v-else></el-empty> -->

                    <div class="br_bottom" v-if="tabList[tabIndex] && tabList[tabIndex].evaluate">
                        <div class="brb_top">课堂分析结果</div>
                        <div class="brb_bottom" v-html="markedt(preprocessLaTeX(tabList[tabIndex].evaluate))"></div>
                        <!-- <div class="brb_btn">查看分析结果</div> -->
                        <!-- <el-empty description="暂无数据" v-else></el-empty> -->
                    </div>
                    <div class="zw" v-if="tabList[tabIndex] && tabList[tabIndex].evaluateStatus == 0">
                        <img src="../../assets/img/i74.png" />
                        还没有分析结果哦~
                    </div>
                    <div class="zw" v-if="tabList[tabIndex] && tabList[tabIndex].evaluateStatus == 1">
                        <img src="../../assets/img/i75.png" style="width: 85px;margin-bottom: 0;" />
                        正在分析中~
                    </div>
                </div>
            </div>
        </div>
        <div class="pop" v-if="flag">
            <div class="p_bg" @click.stop="flag = false"></div>
            <div class="chat">
                <img class="chat_left" src="../../assets/img/ljt.png" @click="btn_backStu" />
                <img class="chat_right" src="../../assets/img/rjt.png" @click="btn_nextStu" />
                <div class="ch_top">
                    <img class="close" src="../../assets/img/i18.png" @click="flag = false, stuId = ''" />
                    <div class="cht_left">个体对话详情</div>
                    <div class="cht_right">
                        <div class="htr_stu">
                            <!-- <img :src="webImg + stuItem.avatar" /> -->
                            {{ stuItem.studentName }}
                        </div>
                        与
                        <div class="htr_znt">
                            <!-- <img :src="webImg + tabList[tabIndex].icon" /> -->
                            {{ tabList[tabIndex].helperName }}
                        </div>
                        的对话
                    </div>
                </div>
                <div class="ch_bottom" ref="scrollDiv">
                    <div class="chb_item" v-for="(item, index) in chatList" :key="index"
                        v-if="(index != 1 && tabList[tabIndex].type == 4) || tabList[tabIndex].type != 4">
                        <div class="chb_left" v-if="item.senderType == 0">
                            <img class="hbl_left" :src="webImg + tabList[tabIndex].icon" />
                            <div class="hbl_right">
                                <div class="blr_top" v-html="markedt(preprocessLaTeX(item.content))"></div>
                                <!-- <div class="blr_bottom">
                                        <div class="lrb_btn">
                                            <img src="../../assets/img/i23.png" />
                                            下载
                                        </div>
                                        <div class="lrb_btn">
                                            <img src="../../assets/img/i22.png" />
                                            复制
                                        </div>
                                    </div> -->
                            </div>
                        </div>

                        <div class="chb_right" v-else>
                            <div class="hbr_text">
                                <el-image class="hbr_img" :preview-src-list="[webImg + itemA]" :src="webImg + itemA"
                                    v-for="(itemA, indexA) in item.imgArr" :key="indexA" v-if="item.path.length > 0">
                                </el-image>
                                <!-- <img class="hbr_img" :src="webImg + itemA" v-for="(itemA, indexA) in item.imgArr"
                                    :key="indexA" v-if="item.path.length > 0" /> -->
                                <div v-if="item.content">{{ item.content }}</div>
                            </div>

                            <img class="hbr_tx" :src="webImg + stuItem.avatar" />
                        </div>
                    </div>
                    <el-empty description="暂无数据" v-if="chatList.length == 0"></el-empty>
                </div>
            </div>
            <div class="b_right">
                <div class="br_tit">数据看板</div>
                <div class="br_box" id="twoChart" v-if="chartInfo1 && chartInfo1.indicator.length > 0"></div>
                <el-empty description="暂无数据" v-else></el-empty>
                <div class="br_bottom">
                    <div class="brb_top">课堂分析结果</div>
                    <div class="brb_bottom" v-html="markedt(preprocessLaTeX(stuEvaluate || ''))" v-if="stuEvaluate">
                    </div>
                    <el-empty description="暂无数据" v-else></el-empty>
                </div>
            </div>
        </div>
        <div class="pop" v-if="flag1">
            <div class="p_bg" @click.stop="flag1 = false"></div>
            <div class="addClass">
                <div class="ac_title">
                    <div>班级分析</div>
                    <img src="../../assets/img/i18.png" @click="flag1 = false" />
                </div>
                <div class="ac_content">
                    <div class="tj_top">
                        <div class="tjt_top">{{ ktInfo.courseName }}</div>
                        <div class="tjt_bottom">班级：{{ ktInfo.className }} <div></div> 学科：{{ ktInfo.subjectName }} <div>
                            </div>
                            上课人数：{{ stuList.length }}人 <div></div> 上课老师：{{ userInfo.nickName }}</div>
                    </div>
                    <div class="tj_bottom">
                        <div class="tjb_left">
                            <div class="jbl_top">
                                <div class="blt_left">班级智能体使用数据雷达图</div>
                                <!-- <div class="blt_right">数量：{{ tabList.length }}</div> -->
                            </div>
                            <div class="jbl_bottom" id="threeChart"
                                v-if="threeChartInfo && threeChartInfo.indicator.length > 0"></div>
                            <el-empty description="暂无数据" v-else></el-empty>
                        </div>
                        <div class="tjb_right">
                            <div class="jbr_top">智能体使用情况分析说明</div>
                            <div class="jbr_bottom" v-html="markedt(preprocessLaTeX(ktInfo.evaluate))"
                                v-if="ktInfo.evaluate"></div>
                            <el-empty description="暂无数据" v-else></el-empty>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pop" v-if="flag3">
            <div class="p_bg" @click.stop="flag3 = false"></div>
            <div class="addClass" style="min-height:550px;">
                <div class="ac_title">
                    <div>请选择需要采集数据的智能体</div>
                    <img src="../../assets/img/i18.png" @click="flag3 = false" />
                </div>
                <div class="ac_content">
                    <!-- <div class="cl_list" style="box-sizing: border-box;padding: 0 40px;">
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>①学段</div>
                            <div class="cli_bottom">
                                <el-select disabled v-model="sectionId" placeholder="请选择" @change="sectionChange">
                                    <el-option v-for="item in sectionArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>②学科</div>
                            <div class="cli_bottom">
                                <el-select disabled v-model="subjectId" placeholder="请选择" @change="subjectChange">
                                    <el-option v-for="item in subjectArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>③知识点</div>
                            <div class="cli_bottom">
                                <el-select v-model="knowledgePointId" placeholder="请选择" @change="knowledgePointsChange">
                                    <el-option v-for="item in knowledgePointArr" :key="item.id"
                                        :label="item.knowledgePointsName" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top">④难度</div>
                            <div class="cli_bottom">
                                <el-select clearable v-model="difficultyId" placeholder="请选择">
                                    <el-option v-for="item in difficultyArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top">⑤出题数量</div>
                            <div class="cli_bottom">
                                <el-input-number :controls="false"
                                    @input="questionNum = questionNum.toString().replace(/[^\d.]/g, '')"
                                    v-model="questionNum" :min="1" :max="10" label="请输入"></el-input-number>
                            </div>
                        </div>
                    </div> -->
                    <div class="acc_select">
                        <!-- <div class="ccs_tit">本堂课已使用的智能体 <span>(请注意关联智能体和难度只能二选一)</span></div> -->
                        <div class="ccs_box">
                            <div class="csb_list">
                                <div class="sbl_tit">待选择</div>
                                <div class="sbl_list">
                                    <div class="bll_item" v-for="(item, index) in availableItems" :key="index"
                                        @click="btn_selectAdd(item, index)">
                                        <img class="lli_left"
                                            :src="item.select == 0 ? require('@/assets/img/i14.png') : require('@/assets/img/i15.png')" />
                                        <div class="lli_right">
                                            <img class="lir_left" :src="webImg + item.icon" />
                                            <div class="lir_right">
                                                <div>{{ item.helperName }}</div>
                                                <div>{{ item.note }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sbl_btn">
                                <div class="blb_btn1" @click="addItems">添加</div>
                                <div class="blb_btn2" @click="removeItems">移除</div>
                            </div>
                            <div class="csb_list">
                                <div class="sbl_tit">已选择（{{ selectedItems.length }}）</div>
                                <div class="sbl_list">
                                    <div class="bll_item" v-for="(item, index) in selectedItems" :key="index"
                                        @click="btn_selectRemove(item, index)">
                                        <img class="lli_left"
                                            :src="item.select == 0 ? require('@/assets/img/i14.png') : require('@/assets/img/i15.png')" />
                                        <div class="lli_right">
                                            <img class="lir_left" :src="webImg + item.icon" />
                                            <div class="lir_right">
                                                <div>{{ item.helperName }}</div>
                                                <div>{{ item.note }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ccs_bottom">
                            <div class="csb_btn" @click="flag3 = false">取消</div>
                            <div class="csb_btn1" @click="submit">提交</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pop" v-if="flag4">
            <div class="p_bg" @click.stop="flag4 = false"></div>
            <div class="chat">
                <div class="ch_top">
                    <img class="close" src="../../assets/img/i18.png" @click="flag4 = false" />
                    <div class="cht_left">点评详情</div>
                </div>
                <div class="ch_bottom" ref="scrollDiv" :infinite-scroll-distance="50" :infinite-scroll-immediate="false"
                    v-infinite-scroll="load">
                    <div class="chb_item" v-for="(item, index) in commentList" :key="index">
                        <div class="chb_left">
                            <img class="hbl_left" :src="webImg + item.avatar" />
                            <div class="hbl_right">
                                <div class="blr_top" style="margin-bottom: 10px;"
                                    v-html="markedt(preprocessLaTeX(item.content))"></div>
                                <div class="blr_img" v-if="item.pictures.length > 0">
                                    <el-image :src="webImg + itemA" v-for="(itemA, indexA) in item.pictures"
                                        :key="indexA" :preview-src-list="[webImg + item.pictures]"></el-image>
                                </div>
                                {{ item.nickName }} 于 {{ item.createTime }} 点评
                            </div>
                        </div>
                    </div>
                    <el-empty description="暂无数据" v-if="commentList.length == 0"></el-empty>
                </div>
            </div>
            <div class="b_right">
                <!-- <el-empty description="暂无数据"></el-empty> -->
                <div class="br_tit">点评二维码</div>
                <el-image :src="webImg + ktInfo.backupQrCode" :preview-src-list="[webImg + ktInfo.backupQrCode]"
                    v-if="ktInfo && ktInfo.backupQrCode"></el-image>
                <!-- <div class="br_box"></div> -->
                <!-- <div class="br_bottom">
                    <div class="brb_top">课堂分析结果</div>
                    <div class="brb_bottom" v-html="markedt(stuEvaluate || '')" v-if="stuEvaluate"></div>
                    <el-empty description="暂无数据" v-else></el-empty>
                </div> -->
            </div>
        </div>
        <el-dialog title="提示" :visible.sync="finishClassPop" width="30%">
            <span>是否确定结束上课?结束后课堂将进行AI分析，重新上课请点击新建课堂</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="finishClassPop = false">取 消</el-button>
                <el-button type="primary" @click="btn_finish">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import MarkdownIt from 'markdown-it'
// import mk from 'markdown-it-katex';
import '@/assets/katex/dist/katex.min.css';
import markdownItKatex from '@iktakahiro/markdown-it-katex';

import {
    courseHelperList,
    courseInfo,
    courseStuList,
    courseStuMsgList,
    updateTechClassHelperStatus,
    finishTechClassCourse,
    startTechClassCourse,
    courseStatisticalAnalysis,
    techClassHelperStudent,
    courseBindingHelper,
    courseOpenHelper,
    courseCommentList,
    courseHelperSet,
    sectionSubject,
    knowledgePointsOption,
    updateHelperPause,
    updateStudentPause
} from '@/apis/index'
const markdownRender = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true
});
markdownRender.use(markdownItKatex);
// markdownRender.use(mk);
export default {
    data() {
        return {
            flag3: false,
            finishClassPop: false,
            flag1: false,
            flag: false,
            tab: 0,
            ktId: '',
            ktInfo: {},
            tabList: [],
            tabIndex: 0,
            helperId: '',
            stuList: [],
            stuId: '',
            stuIndex: 0,
            chatList: [],
            zntStatus: null,
            stuItem: {},
            chartInfo: {},
            chartInfo1: {},
            stuEvaluate: '',
            userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
            threeChartInfo: {},
            zntEve: '',
            timer: '',
            isOne: true,
            availableItems: [],//可添加的项目列表
            selectedItems: [],//已添加的项目列表
            selectedAvailable: [], //存储选中的项目用于存储当前选中的项目
            selectedSelected: [],//用于存储当前选中的项目
            flag4: false,//控制点评弹窗
            commentList: [],//评论列表
            pageNum: 1,
            total: 0,
            isConnectedA: false,
            reconnectCountA: 0,       // 当前重连次数
            maxReconnectCountA: 5,    // 最大重连次数
            reconnectIntervalA: 3000, // 重连间隔
            manualCloseA: false,       // 是否手动关闭
            isConnectedB: false,
            reconnectCountB: 0,       // 当前重连次数
            maxReconnectCountB: 5,    // 最大重连次数
            reconnectIntervalB: 3000, // 重连间隔
            manualCloseB: false,       // 是否手动关闭
            wsA: null, // WebSocket 实例 - 服务器
            wsB: null, // WebSocket 实例 - 管理端
            wsUrlDevApi: 'ws://192.168.3.134:9898/api/websocket/',//开发环境连接服务器的心跳地址
            wsUrlDevManage: 'ws://192.168.3.134:9899/manage/websocket/',//开发环境连接管理端的心跳地址
            wsUrlProApi: 'wss://test.laoshiai.cn/api/websocket/',//生产环境连接服务器的心跳地址
            wsUrlProManage: 'wss://test.laoshiai.cn/manage/websocket/',//生产环境连接管理端的心跳地址
            isDev: false, // 是否是开发环境
            sectionArr: [],
            sectionId: '',
            subjectArr: [],
            subjectId: '',
            tarArr: [],
            tarId: '',
            knowledgePointArr: [],
            knowledgePointId: '',
            knowledgePointsName: '',
            difficultyArr: [{ id: 1, name: '简单' }, { id: 2, name: '中等' }, { id: 3, name: '困难' }],
            difficultyId: '',
            questionNum: 1,
            ifPause: 0,
            oneChart: null,
            twoChart: null
        }
    },
    created() {
        if (process.env.NODE_ENV === 'development') { //development   production
            //开发环境
            this.isDev = true;
        } else {
            //正式环境
            this.isDev = false;
        }
        this.initWebSocketApi();
        this.initWebSocketManage();
    },
    mounted() {
        if (this.$route.query.id) {
            this.ktId = this.$route.query.id
            this.getCourseInfo()
        }
    },
    beforeDestroy() {
        this.closeWebSocketApi();
        this.closeWebSocketManage();
    },
    methods: {
        btn_backStu() {
            this.throttle(() => {
                if (this.stuIndex == 0 || this.stuIndex == null || this.stuIndex == '' || this.stuIndex == undefined) {
                    return false
                }
                this.stuIndex--
                this.stuItem = this.stuList[this.stuIndex]
                this.stuId = this.stuList[this.stuIndex].studentId
                console.log(this.stuIndex, 'stuIndex', this.stuItem);
                this.getCourseStuMsgList()
                this.stuEvaluate = ''
                this.gettechClassHelperStudent()
                setTimeout(() => {
                    this.getcourseStatisticalAnalysis()
                }, 500);
            })
        },
        btn_nextStu() {
            this.throttle(() => {
                if (this.stuIndex == this.stuList.length - 1) {
                    return false
                }
                this.stuIndex++
                this.stuItem = this.stuList[this.stuIndex]
                this.stuId = this.stuList[this.stuIndex].studentId
                console.log(this.stuIndex, 'stuIndex', this.stuItem);
                this.getCourseStuMsgList()
                this.stuEvaluate = ''
                this.gettechClassHelperStudent()
                setTimeout(() => {
                    this.getcourseStatisticalAnalysis()
                }, 500);
            })
        },
        btn_stuPause(item, index) {
            if (!item.id) {
                return this.$message.warning('该学生尚未进入当前智能体对话界面，无法暂停使用')
            }
            updateStudentPause(this.helperId, item.studentId, item.ifPause == 0 || item.ifPause == null ? 1 : 0).then(res => {
                console.log(res, 'updateStudentPause');
                this.getCourseStuList()
            })
        },
        btn_pauseOrContinue() {
            updateHelperPause(this.helperId, this.ifPause == 0 ? 1 : 0).then(res => {
                console.log(res, '暂停状态');
                this.getCourseHelperList()
            })
        },
        knowledgePointsChange(e) {
            console.log(e, 'ee');
            this.knowledgePointsName = this.knowledgePointArr.find(item => item.id == e).knowledgePointsName
        },
        // 知识点
        getKnowledgePointsOption() {
            knowledgePointsOption(this.subjectId).then(res => {
                console.log(res, 'knowledgePointsOption');
                this.knowledgePointArr = res.data
            })
        },
        // 学科变化事件
        subjectChange(e) {
            this.tarId = ''
            this.tarArr = []
            this.knowledgePointId = ''
            this.knowledgePointArr = []
            this.getKnowledgePointsOption()
        },
        // 学段变化事件
        sectionChange(e) {
            this.subjectId = ''
            this.subjectArr = []
            this.tarId = ''
            this.tarArr = []
            this.knowledgePointId = ''
            this.knowledgePointArr = []
            console.log(e, 'e', this.sectionArr.find(item => item.id == e));
            this.subjectArr = this.sectionArr.find(item => item.id == e).subjectList
        },
        getSectionSubject() {
            sectionSubject(2).then(res => {
                console.log(res, 'sectionSubject');
                this.sectionArr = res.data
                if (this.sectionArr.length > 0 && this.subjectId) {
                    this.subjectArr = this.sectionArr.find(item => item.id == this.sectionId).subjectList
                    this.getKnowledgePointsOption()
                }
            })
        },
        // 连接管理端
        initWebSocketManage() {
            this.closeWebSocketManage();
            if (this.isDev) {
                this.wsB = new WebSocket(this.wsUrlDevManage + this.ktId);
            } else {
                this.wsB = new WebSocket(this.wsUrlProManage + this.ktId);
            }
            // this.ws = new WebSocket(`ws://192.168.3.134:9899/manage/websocket/` + this.ktId);

            this.wsB.onopen = () => {
                console.log('WebSocket connectedManage');
                this.isConnectedB = true;
                this.reconnectCountB = 0; // 重置重连计数器
            };

            this.wsB.onmessage = (event) => {
                console.log(event, 'onmessage');
                if (event.data == 'update') {
                    this.getCourseHelperList()
                }
            };

            this.wsB.onerror = (error) => {
                console.error('WebSocket error:', error);
                this.reconnectManage();
            };

            this.wsB.onclose = (event) => {
                this.isConnectedB = false;
                if (!this.manualCloseB) {
                    console.log('连接断开，尝试重连...');
                    this.reconnectManage();
                }
            };
        },
        reconnectManage() {
            if (this.reconnectCountB < this.maxReconnectCountB) {
                setTimeout(() => {
                    console.log(`尝试第 ${this.reconnectCountB + 1} 次重连`);
                    this.reconnectCountB++;
                    this.initWebSocketManage();
                }, this.reconnectIntervalB * Math.pow(2, this.reconnectCountB)); // 指数退避
            } else {
                console.error(`已达到最大重连次数（${this.maxReconnectCountB}）`);
            }
        },
        closeWebSocketManage() {
            this.manualCloseB = true;
            if (this.wsB) {
                this.wsB.close();
                this.wsB = null;
            }
        },
        initWebSocketApi() {
            this.closeWebSocketApi()
            if (this.isDev) {
                this.wsA = new WebSocket(this.wsUrlDevApi + this.ktId);
            } else {
                this.wsA = new WebSocket(this.wsUrlProApi + this.ktId);
            }
            // this.ws = new WebSocket('ws://192.168.3.134:9898/api/websocket/' + this.ktId);

            this.wsA.onopen = () => {
                console.log('WebSocket connectedApi');
                this.isConnectedA = true;
                this.reconnectCountA = 0; // 重置重连计数器
            };

            this.wsA.onmessage = (event) => {
                console.log(event, 'onmessage');
                if (event.data == 'update') {
                    this.getCourseHelperList()
                }
            };

            this.wsA.onerror = (error) => {
                console.error('WebSocket error:', error);
                this.reconnectApi();
            };

            this.wsA.onclose = (event) => {
                this.isConnectedA = false;
                if (!this.manualCloseA) {
                    console.log('连接断开，尝试重连...');
                    this.reconnectApi();
                }
            };
        },

        reconnectApi() {
            if (this.reconnectCountA < this.maxReconnectCountA) {
                setTimeout(() => {
                    console.log(`尝试第 ${this.reconnectCountA + 1} 次重连`);
                    this.reconnectCountA++;
                    this.initWebSocketApi();
                }, this.reconnectIntervalA * Math.pow(2, this.reconnectCountA)); // 指数退避
            } else {
                console.error(`已达到最大重连次数（${this.maxReconnectCountA}）`);
            }
        },
        //手动重连
        manualReconnectApi() {
            this.reconnectCountA = 0;
            this.manualCloseA = false;
            this.initWebSocketApi();
        },

        sendMessage() {
            if (this.isConnectedA && this.message.trim()) {
                this.wsA.send(this.message);
            }
        },
        closeWebSocketApi() {
            this.manualCloseA = true;
            if (this.wsA) {
                this.wsA.close();
                this.wsA = null;
            }
        },
        load() {
            this.throttle(() => {
                if (this.total > this.commentList.length) {
                    this.pageNum++
                    this.getCommentList()
                }
            })
        },
        getCommentList() {
            courseCommentList(this.ktId, this.pageNum).then(res => {
                console.log(res, 'res');
                res.data.forEach(item => {
                    if (item.pictures) {
                        item.pictures = item.pictures.split(',')
                    }
                });
                // this.commentList = res.data
                if (this.pageNum == 1) {
                    this.commentList = []
                }
                this.commentList = [...this.commentList, ...res.data]
                this.total = res.total
            })
        },
        //开始出题（弃用）
        submit() {
            // if (this.difficultyId && this.selectedItems.map(item => item.id).join(',')) {
            //     return this.$message.warning('关联智能体和难度只能二选一')
            // }
            // if (this.questionNum < 1 || this.questionNum > 10) {
            //     return this.$message.warning('出题数量只能为1-10')
            // }
            if (this.selectedItems.length == 0) {
                return this.$message.warning('请选择智能体')
            }
            courseHelperSet({
                id: this.tabList[this.tabList.length - 1].id,
                knowledgePointsId: this.knowledgePointId,
                questionNum: this.questionNum,
                sectionId: this.sectionId,
                subjectId: this.subjectId,
                difficultyLevel: this.difficultyId
            }).then(resA => {
                if (!this.difficultyId) {
                    courseBindingHelper({
                        id: this.tabList[this.tabList.length - 1].id,
                        techClassHelperIds: this.selectedItems.map(item => item.id).join(',')
                    }).then(res => {
                        console.log(res, 'courseBindingHelper');
                        courseOpenHelper(this.tabList[this.tabList.length - 1].id).then(res => {
                            console.log(res, 'courseOpenHelper');
                            this.flag3 = false
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            });
                            this.getCourseInfo()
                        })
                    })
                } else {
                    courseOpenHelper(this.tabList[this.tabList.length - 1].id).then(res => {
                        console.log(res, 'courseOpenHelper');
                        this.flag3 = false
                        this.$message({
                            message: '提交成功！',
                            type: 'success'
                        });
                        this.getCourseInfo()
                    })
                }
            })

        },
        btn_selectRemove(item, index) {
            item.select = item.select == 0 ? 1 : 0
            this.$forceUpdate()
            if (item.select == 1) {
                this.selectedSelected.push(item)
            } else {
                this.selectedSelected.splice(index, 1)
            }
        },
        btn_selectAdd(item, index) {
            item.select = item.select == 0 ? 1 : 0
            this.$forceUpdate()
            if (item.select == 1) {
                this.selectedAvailable.push(item)
            } else {
                this.selectedAvailable.splice(index, 1)
            }
        },
        addItems() {
            this.selectedAvailable.forEach(e => { e.select = 0 })
            this.selectedItems.push(...this.selectedAvailable);
            this.availableItems = this.availableItems.filter(item => !this.selectedAvailable.includes(item));
            this.selectedAvailable = [];
        },
        removeItems() {
            this.selectedSelected.forEach(e => { e.select = 0 })
            this.availableItems.push(...this.selectedSelected);
            this.selectedItems = this.selectedItems.filter(item => !this.selectedSelected.includes(item));
            this.selectedSelected = [];
        },
        markedt(markdown) {
            markdown = markdown.replace(/\$(.*?)\$/g, (match, p1) => {
                // 在匹配的内容中替换乘号和 \frac
                const replaced = p1
                    .replace(/×/g, '\\times') // 替换乘号
                // .replace(/\frac/g, '\\\\frac'); // 替换 \frac
                return `$${replaced}$`; // 返回替换后的内容
            });
            if (markdown) {
                return markdownRender.render(markdown);
            }
            return '';
        },
        // 右下方课堂分析结果数据
        gettechClassHelperStudent() {
            techClassHelperStudent(this.stuId, this.helperId).then(res => {
                console.log(res, 'res');
                this.stuEvaluate = res.data.evaluate
            })
        },
        // 班级分析
        async btn_analysis() {
            await this.getCourseInfo()
            if (this.ktInfo.evaluateStatus == 0) {
                this.$message({
                    message: '下课后才可以查看分析结果！',
                    type: 'warning'
                });
                return
            }
            if (this.ktInfo.evaluateStatus == 1) {
                this.$message({
                    message: 'AI分析中，数据量较大，预计用时2分钟，请耐心等待！',
                    type: 'warning'
                });
                return
            }
            this.flag1 = true
            var list = JSON.parse(JSON.stringify(this.tabList))
            list.forEach((item, index) => {
                item.ifChoose = true
            })
            courseStatisticalAnalysis([], this.ktId).then(res => {
                console.log(res, 'threeChartInfo');
                this.threeChartInfo = res.data[0]
                setTimeout(() => {
                    this.initThreeChart()
                }, 500);
            })
        },
        // 获取右下方课堂图表及学生图表数据
        getcourseStatisticalAnalysis() {
            this.tabList.forEach((item, index) => {
                if (index == this.tabIndex) {
                    item.ifChoose = true
                } else {
                    item.ifChoose = false
                }
            })
            courseStatisticalAnalysis(this.tabList, this.ktId, this.stuId).then(res => {
                console.log(this.chartInfo, 'courseStatisticalAnalysis');
                if (this.stuId) {
                    this.chartInfo1 = res.data[0]
                } else {
                    this.chartInfo = res.data[0]
                }
                setTimeout(() => {
                    if (this.stuId) {
                        if (this.twoChart) {
                            this.twoChart.dispose()
                        }
                        if (this.chartInfo1.indicator.length > 0) {
                            this.initTwoChart()
                        }
                        // this.initTwoChart()
                    } else {
                        if (this.oneChart) {
                            this.oneChart.dispose()
                        }
                        if (this.chartInfo.indicator.length > 0) {
                            this.initChart()
                        }
                    }
                }, 500);
            })
        },
        btn_finish() {
            finishTechClassCourse(this.ktId).then(res => {
                console.log(res, 'res');
                this.finishClassPop = false
                this.getCourseInfo()
            })
        },
        btn_start() {
            startTechClassCourse(this.ktId).then(res => {
                console.log(res, 'res');
                this.getCourseInfo()
            })
        },
        // 智能体开启关闭 type=4为出题助手
        startAndEnd(item, status, type) {
            this.throttle(() => {
                this.$confirm(`确定${status == 0 ? '开启' : '关闭'}吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 如果不是出题助手
                    if (type != 4) {
                        // 更新智能体列表状态
                        this.getCourseHelperList()
                        if (item.evaluateStatus == 1) {
                            this.$message.warning('AI正在分析中，预计用时2分钟，请耐心等待！')
                            return
                        }
                        updateTechClassHelperStatus(status, item.id).then(resA => {
                            console.log(resA, 'res');
                            this.getCourseInfo()
                        })
                    } else if (type == 4) {
                        // 如果是出题助手
                        if (status == 1) {
                            // 更新智能体列表状态
                            this.getCourseHelperList()
                            if (item.evaluateStatus == 1) {
                                this.$message.warning('AI正在分析中，预计用时2分钟，请耐心等待！')
                                return
                            }
                            updateTechClassHelperStatus(status, item.id).then(resA => {
                                console.log(resA, 'res');
                                this.getCourseInfo()
                            })
                        } else {
                            courseOpenHelper(this.tabList[this.tabList.length - 1].id).then(res => {
                                console.log(res, 'courseOpenHelper');
                                this.$message({
                                    message: '提交成功！',
                                    type: 'success'
                                });
                                this.getCourseInfo()
                            })
                        }
                    }
                })
            })
        },
        isObject(value) {
            return value !== null && typeof value === 'object';
            // return value !== null && typeof value === 'object' && !Array.isArray(value);
        },
        // 获取学生对话列表
        getCourseStuMsgList() {
            this.chatList = []
            courseStuMsgList(this.stuId, this.helperId).then(res => {
                console.log(res)
                this.flag = true
                if (res.data) {
                    res.data.forEach(e => {
                        let content = e.content;
                        // 尝试把content解析成JSON对象
                        try {
                            const parsed = JSON.parse(content);
                            // 如果解析成功且是对象或数组，替换content
                            if (this.isObject(parsed)) {
                                console.log(parsed, 'parsed');
                                content = parsed;
                                var techClassQuestionOpt = [];
                                if (content.data.techClassQuestionOpt && content.data.techClassQuestionOpt.length > 0) {
                                    content.data.techClassQuestionOpt.forEach((item) => {
                                        item.select = false;
                                        item.type = content.data.type
                                    });
                                    techClassQuestionOpt = content.data.techClassQuestionOpt;
                                }
                            }
                        } catch (err) {
                            // 解析失败，content保持原字符串
                        }
                        e.content = content.data && e.senderType == 0 ? content.data.questionContent : content
                        if (e.path) {
                            e.imgArr = e.path.split(',')
                        }
                    })
                    this.chatList = res.data
                    console.log(this.chatList, 'chatList');

                }
            })
        },
        btn_stu(item, index) {
            this.stuId = item.studentId
            this.stuIndex = index
            this.stuItem = item
            this.getCourseStuMsgList()
            this.stuEvaluate = ''
            this.gettechClassHelperStudent()
            setTimeout(() => {
                this.getcourseStatisticalAnalysis()
            }, 500);
        },
        // 获取课堂学生列表
        getCourseStuList() {
            courseStuList(this.helperId).then(res => {
                console.log(res)
                this.stuList = res.data
            })
        },
        // 切换智能体
        btn_tab(index) {
            this.tabIndex = index
            this.helperId = this.tabList[index].id
            this.ifPause = this.tabList[index].ifPause
            this.getCourseHelperList()
        },
        // 获取课堂详情信息
        getCourseInfo() {
            courseInfo(this.ktId).then(res => {
                console.log(res)
                this.ktInfo = res.data
                this.sectionId = res.data.sectionId
                this.subjectId = res.data.subjectId
                this.getSectionSubject()
                this.getCourseHelperList()
            })
        },
        // 获取课程智能体
        getCourseHelperList() {
            // let loading = this.$loading({
            //     lock: true,
            //     text: '加载中...',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // });
            // this.tabList = []
            courseHelperList(this.ktId).then(res => {
                console.log(res)
                this.tabList = res.data
                // 这一步处理的是后续出题助手弹窗所展示的数据
                this.availableItems = JSON.parse(JSON.stringify(res.data))
                this.availableItems = this.availableItems.filter(item => item.type != 4);
                this.availableItems.forEach(e => { e.select = 0 })
                this.$forceUpdate()
                this.helperId = this.tabList[this.tabIndex].id
                this.ifPause = this.tabList[this.tabIndex].ifPause
                this.getCourseStuList()
                this.getcourseStatisticalAnalysis()
            }).finally(() => {
                // setTimeout(() => {
                //     loading.close();
                // }, 500);
            })
        },
        initThreeChart() {
            var option = {
                // color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
                tooltip: {},
                legend: {
                    data: this.threeChartInfo.legend,
                    left: 'center',
                    top: '25',
                    icon: 'roundRect',
                    itemWidth: 12,
                    itemHeight: 12,
                    show: false
                },
                radar: {
                    radius: '50%',
                    center: ["center", "center"],
                    // shape: 'circle',
                    indicator: this.threeChartInfo.indicator
                },
                series: [
                    {
                        type: 'radar',
                        data: this.threeChartInfo.seriesData,
                        areaStyle: {}
                    }
                ]
            };
            const myChart = this.$echarts.init(document.getElementById('threeChart'))
            myChart.setOption(option)
        },
        initTwoChart() {
            const maxLength = Math.max(...this.chartInfo1.indicator.map(item => item.name.length));

            var option = {
                color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
                tooltip: {
                    appendToBody: true,//// 让 tooltip 挂载到 body，避免被裁剪
                },
                legend: {
                    data: this.chartInfo1.legend,
                    left: 'center',
                    top: '0%',
                    icon: 'roundRect',
                    itemWidth: 12,
                    itemHeight: 12,
                },
                radar: {
                    radius: maxLength >= 8 ? '30%' : '45%',
                    center: ["center", "center"],
                    // shape: 'circle',
                    name: {
                        textStyle: {
                            rich: {
                                a: {
                                    fontSize: 12,
                                    lineHeight: 15
                                    // color: '#000000'   // ← your desired color
                                }
                            }
                        },
                    },
                    indicator: this.chartInfo1.indicator
                },
                series: [
                    {
                        type: 'radar',
                        data: this.chartInfo1.seriesData,
                        areaStyle: {}
                    }
                ]
            };
            this.twoChart = this.$echarts.init(document.getElementById('twoChart'))
            this.twoChart.setOption(option)
        },
        initChart() {
            const maxLength = Math.max(...this.chartInfo.indicator.map(item => item.name.length));
            this.oneChart = this.$echarts.init(document.getElementById('oneChart'))
            var option = {
                color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
                tooltip: {
                    appendToBody: true
                },
                legend: {
                    data: this.chartInfo.legend,
                    left: 'center',
                    top: '0%',
                    icon: 'roundRect',
                    itemWidth: 12,
                    itemHeight: 12,
                },
                radar: {
                    radius: maxLength >= 8 ? '38%' : '60%',
                    center: ["center", "center"],
                    // shape: 'circle',
                    name: {
                        textStyle: {
                            rich: {
                                a: {
                                    fontSize: 12,
                                    lineHeight: 15
                                    // color: '#000000'   // ← your desired color
                                }
                            }
                        },
                        // formatter: function (name) {
                        //     // 每 5 个字符换行一次
                        //     const wrap = name.replace(/(.{9})/g, '$1\n');
                        //     return wrap;
                        // },
                    },
                    indicator: this.chartInfo.indicator
                },
                series: [
                    {
                        type: 'radar',
                        data: this.chartInfo.seriesData,
                        areaStyle: {}
                    }
                ]
            };
            this.oneChart.setOption(option)
            // window.addEventListener('resize', () => {
            //     setTimeout(() => {
            //         myChart.resize()
            //     }, 500)
            // })
        },
        // 滚动到底部
        handleScrollBottom() {
            this.$nextTick(() => {
                let scrollElem = this.$refs.scrollDiv;
                scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.zw {
    width: 100%;
    // height: 100%;
    margin-top: 115px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    color: #898B8F;
    user-select: none;

    img {
        width: 76px;
        height: 76px;
        margin-bottom: 20px;
    }
}

::v-deep {
    .el-input-number .el-input__inner {
        text-align: left !important;
    }

    .el-select {
        width: 100% !important;
    }

    img {
        width: 100%;
    }

    code {
        /*元素内的空白保留，并允许换行*/
        white-space: pre-wrap !important;
        /*是否允许在单词内断句*/
        word-wrap: break-word !important;
        font-family: PingFang;
    }

    .katex-html {
        // display: none !important;
    }

    annotation {
        display: none !important;
    }

    table {
        border-collapse: collapse;
        /* 确保表格的边框线会合并为单一的线条 */
        border: 1px solid black;
        /* 设置表格的边框 */
    }

    td,
    th {
        border: 1px solid black;
        /* 设置单元格的边框 */
    }

    h1 {
        font-size: 16px;
        font-weight: bold;
    }

    h2 {
        font-size: 16px;
        font-weight: bold;
    }

    h3 {
        font-size: 16px;
        font-weight: bold;
    }

    p {
        font-size: 16px;
    }

    li {
        font-size: 16px;
    }
}

.addClass {
    width: 972px;
    height: 650px;
    background: #FFFFFF;
    border-radius: 10px;
    position: absolute;
    top: 370px;
    /* 距离顶部 50% */
    left: 50%;
    /* 距离左侧 50% */
    transform: translate(-50%, -50%);
    z-index: 4;

    .ac_title {
        width: 100%;
        height: 42px;
        border-radius: 10px 10px 0 0;
        background: #F4F6FB;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 20px;

        div {
            font-weight: bold;
            font-size: 18px;
            color: #000000;
        }

        img {
            width: 16px;
            height: 16px;
            cursor: pointer;
        }
    }

    .ac_content {
        width: 100%;

        .cl_list {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;

            .cl_item {
                width: 47%;
                margin-bottom: 20px;
                display: flex;
                align-items: center;

                .cli_top {
                    width: 85px;
                    font-weight: bold;
                    font-size: 12px;
                    color: #252525;

                    span {
                        font-weight: 500;
                        font-size: 16px;
                        color: #FF0000;
                    }
                }

                .cli_bottom {
                    flex: 1;

                    // height: 25px;
                    .libi {
                        background: #2992FF !important;
                        color: #fff !important;
                    }

                    .lib_item {
                        width: fit-content;
                        padding: 6px 13px;
                        background: #F1F1F1;
                        border-radius: 1px 1px 1px 1px;
                        font-weight: 500;
                        font-size: 10px;
                        color: #020202;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        user-select: none;
                        cursor: pointer;
                    }

                    // width: 100%;
                    // width: 255px;
                    .lib_btn {
                        width: 91px;
                        height: 37px;
                        border-radius: 8px 8px 8px 8px;
                        border: 1px solid #399AFF;
                        font-weight: bold;
                        font-size: 16px;
                        color: #2992FF;
                        text-align: center;
                        line-height: 37px;
                        margin-left: 20px;
                        cursor: pointer;
                    }

                    .lib_img {
                        width: 80px;
                        height: 80px;
                        cursor: pointer;
                        border-radius: 8px;
                    }

                    .lib_add {
                        width: 80px;
                        height: 80px;
                        background: #FFFFFF;
                        border-radius: 2px 2px 2px 2px;
                        border: 1px solid #E2E6ED;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        font-weight: 500;
                        font-size: 14px;
                        color: #999999;
                        cursor: pointer;

                        img {
                            width: 18px;
                            height: 18px;
                            margin-bottom: 10px;
                        }
                    }
                }
            }
        }

        .acc_input {
            width: 100%;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            padding: 0 210px 0 30px;
            margin-top: 15px;

            .cci_left {
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                width: 130px;
                text-align: right;

                span {
                    font-weight: bold;
                    font-size: 14px;
                    color: #FF0000;
                    margin-right: 4px;
                }
            }

            input {
                flex: 1;
                margin-left: 10px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #CED4DB;
                box-sizing: border-box;
                padding: 0 8px;
            }
        }

        .acc_line {
            width: 100%;
            height: 1px;
            background-color: #ECECEC;
            margin: 20px 0;
        }

        .acc_select {
            width: 100%;
            height: 100%;

            .ccs_tit {
                width: 100%;
                box-sizing: border-box;
                // padding: 0 210px 0 75px;
                font-weight: bold;
                font-size: 16px;
                color: #252525;
                margin-bottom: 15px;

                span {
                    font-weight: bold;
                    font-size: 14px;
                    color: #FF0000;
                    margin-right: 4px;
                }
            }

            .ccs_box {
                width: 100%;
                height: calc(100% - 70px);
                display: flex;
                align-items: center;
                justify-content: center;

                .csb_list {
                    width: 280px;
                    height: 480px;
                    border-radius: 8px 8px 8px 8px;
                    border: 1px solid #F0F0F0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .sbl_tit {
                        width: 100%;
                        height: 35px;
                        border-bottom: 1px solid#ECECEC;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;
                        line-height: 35px;
                        box-sizing: border-box;
                        padding: 0 20px;
                    }

                    .sbl_list::-webkit-scrollbar {
                        display: none;
                    }

                    .sbl_list {
                        width: 100%;
                        height: 0;
                        flex: 1;
                        overflow-y: scroll;

                        .bll_item {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding: 0 20px;
                            margin-top: 15px;
                            cursor: pointer;

                            .lli_left {
                                width: 14px;
                                height: 14px;
                            }

                            .lli_right {
                                flex: 1;
                                display: flex;
                                align-items: center;
                                margin-left: 15px;

                                .lir_left {
                                    width: 36px;
                                    height: 36px;
                                }

                                .lir_right {
                                    flex: 1;
                                    margin-left: 8px;

                                    div:nth-child(1) {
                                        font-weight: 500;
                                        font-size: 16px;
                                        color: #000000;
                                    }

                                    div:nth-child(2) {
                                        font-weight: 500;
                                        font-size: 12px;
                                        color: #999999;
                                        margin-top: 8px;
                                    }
                                }
                            }
                        }
                    }
                }

                .sbl_btn {
                    margin: 0 30px;

                    .blb_btn1 {
                        width: 64px;
                        height: 36px;
                        background: #399AFF;
                        border-radius: 8px 8px 8px 8px;
                        font-weight: bold;
                        font-size: 16px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 36px;
                        cursor: pointer;

                    }

                    .blb_btn2 {
                        width: 64px;
                        height: 36px;
                        background: #F75A5A;
                        border-radius: 8px 8px 8px 8px;
                        font-weight: bold;
                        font-size: 16px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 36px;
                        margin-top: 30px;
                        cursor: pointer;

                    }
                }
            }

            .ccs_bottom {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 20px;

                .csb_btn {
                    width: 164px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    border: 1px solid #399AFF;
                    font-weight: bold;
                    font-size: 16px;
                    color: #399AFF;
                    text-align: center;
                    line-height: 40px;
                    margin: 0 7px;
                    cursor: pointer;
                }

                .csb_btn1 {
                    width: 164px;
                    height: 40px;
                    background: #399AFF;
                    border-radius: 8px 8px 8px 8px;
                    font-weight: bold;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 40px;
                    margin: 0 7px;
                    cursor: pointer;
                }
            }
        }
    }
}

.line1_ {
    white-space: pre-wrap;
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.body {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    // z-index: 1;

    .popup {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 2;
    }

    .addClass {
        width: 972px;
        height: 650px;
        background: #FFFFFF;
        border-radius: 10px;
        position: absolute;
        top: 370px;
        /* 距离顶部 50% */
        left: 50%;
        /* 距离左侧 50% */
        transform: translate(-50%, -50%);
        z-index: 3;
        display: flex;
        flex-direction: column;
        align-items: center;

        .ac_title {
            width: 100%;
            height: 42px;
            background: #F4F6FB;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 20px;
            border-radius: 10px 10px 0 0;


            div {
                font-weight: bold;
                font-size: 18px;
                color: #000000;
            }

            img {
                width: 16px;
                height: 16px;
                cursor: pointer;
            }
        }

        .ac_content {
            width: 100%;
            height: 0;
            flex: 1;
            box-sizing: border-box;
            padding: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .tj_top {
                width: 100%;
                height: 120px;
                box-sizing: border-box;
                padding: 20px;
                background: #2992FF;
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;

                .tjt_top {
                    width: 100%;
                    text-align: left;
                    font-weight: bold;
                    font-size: 28px;
                    color: #FFFFFF;
                }

                .tjt_bottom {
                    width: 100%;
                    text-align: left;
                    font-weight: 500;
                    font-size: 18px;
                    color: #FFFFFF;
                    display: flex;
                    align-items: center;

                    div {
                        width: 2px;
                        height: 18px;
                        background-color: #fff;
                        margin: 0 15px;
                    }
                }
            }

            .tj_bottom {
                flex: 1;
                height: 0;
                width: 100%;
                display: flex;
                align-items: flex-start;
                margin-top: 30px;

                .tjb_left {
                    width: 50%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    border-right: 1px solid#ECECEC;

                    .jbl_top {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        box-sizing: border-box;
                        padding-right: 30px;

                        .blt_left {
                            font-weight: bold;
                            font-size: 20px;
                            color: #000000;
                        }

                        .blt_right {
                            font-weight: bold;
                            font-size: 16px;
                            color: #2992FF;
                        }
                    }

                    .jbl_bottom {
                        width: 100%;
                        height: 0;
                        flex: 1;
                    }
                }

                .tjb_right {
                    width: 50%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;

                    .jbr_top {
                        padding-left: 30px;
                        font-weight: bold;
                        font-size: 20px;
                        color: #000000;
                    }

                    .jbr_bottom::-webkit-scrollbar {
                        display: none;
                    }

                    .jbr_bottom {
                        width: 100%;
                        height: 350px;
                        box-sizing: border-box;
                        padding-right: 30px;
                        overflow-y: scroll;
                        padding-left: 30px;
                        font-weight: 500;
                        font-size: 14px;
                        color: #666666;
                        line-height: 28px;
                        margin-top: 30px;
                    }
                }
            }
        }
    }

    .pop {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;

        .p_bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 2;
        }

        .b_right::-webkit-scrollbar {
            display: none;
        }

        .b_right {
            z-index: 4;
            background-color: #fff;
            width: 380px;
            height: 700px;
            border: 1px solid #EDEDED;
            border-radius: 0px 30px 30px 0px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow-y: scroll;
            box-sizing: border-box;

            .br_tit {
                width: 100%;
                box-sizing: border-box;
                padding: 20px;
                font-weight: bold;
                font-size: 20px;
                color: #000000;

            }

            .br_box {
                // flex: 1;
                height: 380px;
                width: 100%;
            }

            .br_bottom {
                width: 100%;
                box-sizing: border-box;
                padding: 20px;



                .brb_top {
                    font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                }

                .brb_bottom {
                    width: 100%;
                    // height: 70px;
                    // overflow-y: scroll;
                    font-weight: 500;
                    font-size: 14px;
                    color: #666666;
                    line-height: 28px;
                    margin-top: 15px;
                }
            }
        }
    }

    .chat {
        // flex: 1;
        // height: 0;
        // position: absolute;
        // top: 370px;
        /* 距离顶部 50% */
        // left: 50%;
        /* 距离左侧 50% */
        // transform: translate(-50%, -50%);
        z-index: 4;
        background-color: #fff;
        width: 1000px;
        height: 700px;
        border-radius: 30px 0px 0px 30px;
        border: 1px solid #EDEDED;
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .chat_left {
            width: 30px;
            height: 30px;
            cursor: pointer;
            position: absolute;
            left: 10px;
            top: 300px;
            z-index: 29;
            background-color: #fff;
            border-radius: 50%;

        }

        .chat_right {
            width: 30px;
            height: 30px;
            cursor: pointer;
            position: absolute;
            right: 10px;
            top: 300px;
            z-index: 29;
            background-color: #fff;
            border-radius: 50%;

        }

        .ch_top {
            width: 100%;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid#ECECEC;
            position: relative;
            box-sizing: border-box;
            // padding: 0 30px;

            .close {
                position: absolute;
                right: 10px;
                top: 20px;
                width: 16px;
                height: 16px;
                cursor: pointer;
            }

            .cht_left {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                line-height: 60px;
            }

            .cht_right {
                display: flex;
                align-items: center;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                line-height: 60px;
                margin-right: 50px;

                .htr_stu {
                    font-weight: 500;
                    font-size: 16px;
                    color: #2992FF;
                    margin-right: 10px;

                    img {
                        width: 36px;
                        height: 36px;
                        margin-right: 5px;
                    }
                }

                .htr_znt {
                    font-weight: 500;
                    font-size: 16px;
                    color: #2992FF;
                    margin-left: 10px;
                    margin-right: 10px;

                    img {
                        width: 36px;
                        height: 36px;
                        margin-right: 5px;
                    }
                }
            }
        }

        .ch_bottom::-webkit-scrollbar {
            display: none;
        }

        .ch_bottom {
            width: 100%;
            height: 0;
            flex: 1;
            overflow-y: scroll;
            margin-bottom: 15px;

            .chb_item {
                width: 100%;
                margin-top: 20px;

                .chb_left {
                    width: 100%;
                    display: flex;
                    align-items: flex-start;

                    .hbl_left {
                        width: 44px;
                        height: 44px;
                        border-radius: 6px;
                    }

                    .hbl_right {
                        // flex: 1;
                        margin-left: 20px;
                        max-width: 500px;
                        background: #FAFAFA;
                        border-radius: 10px 10px 10px 10px;
                        box-sizing: border-box;
                        padding: 10px;

                        .blr_img {
                            width: 100%;
                            display: flex;
                            flex-wrap: wrap;
                            margin-right: 10px;
                            margin-bottom: 10px;
                        }

                        .blr_top {
                            font-weight: 500;
                            font-size: 16px;
                            color: #333333;
                            line-height: 32px;
                        }

                        .blr_bottom {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            border-top: 1px solid#ececec;
                            margin-top: 10px;
                            padding-top: 10px;

                            .lrb_btn {
                                font-weight: 500;
                                font-size: 14px;
                                color: #333333;
                                margin-right: 30px;
                                display: flex;
                                align-items: center;
                                cursor: pointer;

                                img {
                                    width: 14px;
                                    height: 14px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                }

                .chb_right {
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-end;

                    .hbr_text {
                        max-width: 500px;
                        background: #2992FF;
                        border-radius: 10px 10px 10px 10px;
                        font-weight: 500;
                        font-size: 16px;
                        color: #FFFFFF;
                        line-height: 32px;
                        box-sizing: border-box;
                        padding: 10px;
                    }

                    .hbr_img {
                        max-width: 500px;
                        border-radius: 10px 10px 10px 10px;
                        box-sizing: border-box;
                        padding: 10px;
                        border-radius: 8px;
                    }

                    .hbr_tx {
                        width: 44px;
                        height: 44px;
                        margin-left: 20px;
                        border-radius: 6px;
                    }
                }
            }
        }
    }

    .bg {
        width: 100%;
        height: 228px;
        background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
        position: absolute;
        top: 0;
        left: 0;
        // z-index: -1;
    }

    .content {
        width: 1200px;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 1;

        .back {
            width: 100%;
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 14px;
            color: #000000;
            margin-bottom: 10px;
            margin-top: 10px;
            cursor: pointer;

            img {
                width: 14px;
                height: 14px;

            }
        }

        .top {
            width: 100%;
            height: 100px;
            background: #2992FF;
            border-radius: 16px 16px 16px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 30px;

            .top_left {
                display: flex;
                align-items: center;

                .t_left {
                    width: 70px;
                    height: 70px;
                    border-radius: 10px 10px 10px 10px;
                }

                .t_right {
                    flex: 1;
                    margin-left: 30px;

                    .tr_top {
                        display: flex;
                        align-items: center;

                        .trt_left {
                            font-weight: bold;
                            font-size: 24px;
                            color: #FFFFFF;
                            margin-right: 14px;
                        }

                        .trt_right {
                            width: 115px;
                            height: 28px;
                            background: #FFFFFF;
                            border-radius: 8px 8px 8px 8px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-weight: 800;
                            font-size: 14px;
                            color: #2992FF;
                            cursor: pointer;

                            img:nth-child(1) {
                                width: 16px;
                                height: 16px;
                                margin-right: 2px;
                            }

                            img:nth-child(2) {
                                width: 5px;
                                height: 8px;
                                margin-left: 10px;
                            }
                        }
                    }

                    .tr_bottom {
                        font-weight: 500;
                        font-size: 18px;
                        color: #FFFFFF;
                        margin-top: 18px;
                        display: flex;
                        align-items: center;

                        div {
                            height: 18px;
                            width: 2px;
                            background-color: #fff;
                            margin: 0 15px;
                        }
                    }
                }
            }
        }

        .top_right {
            display: flex;
            align-items: center;

            .tr_btn3 {
                width: 128px;
                height: 36px;
                background: #fff;
                border-radius: 8px 8px 8px 8px;
                font-weight: 800;
                font-size: 16px;
                color: #2992FF;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 20px;
                cursor: pointer;

                img {
                    width: 14px;
                    height: 14px;
                    margin-right: 10px;
                }
            }

            .tr_btn2 {
                width: fit-content;
                height: 36px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 800;
                font-size: 16px;
                color: #2992FF;
                margin-right: 20px;
                cursor: pointer;
                box-sizing: border-box;
                padding: 0 10px;

                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                }
            }

            .tr_btn1 {
                width: 128px;
                height: 36px;
                background: #FF4B4B;
                border-radius: 8px 8px 8px 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 800;
                font-size: 16px;
                color: #FFFFFF;
                cursor: pointer;

                img {
                    width: 15px;
                    height: 16px;
                    margin-right: 10px;
                }
            }

            .tr_btn {
                width: 128px;
                height: 36px;
                border: 1px solid #2992FF;
                background: #F2F9FF;
                border-radius: 8px 8px 8px 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 800;
                font-size: 16px;
                color: #2992FF;
                cursor: pointer;

                img {
                    width: 14px;
                    height: 16px;
                    margin-right: 10px;
                }
            }
        }
    }

}

.center {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;

    .c_left::-webkit-scrollbar {
        // display: none;
        // height: 10px;
        // background-color: #1096F1;
    }

    .c_left::-webkit-scrollbar-thumb {
        background: #c2c2c2;
        /* 滑块颜色 */
        border-radius: 10px;
        /* 滑块圆角 */
    }

    .c_left {
        flex: 1;
        // margin-right: 30px;
        overflow-x: scroll;
        padding: 5px;
        white-space: nowrap;

        .cll2 {
            border: 1px solid #2992FF !important;
        }

        .cl_item {
            display: inline-flex;
            width: 180px;
            height: 70px;
            background: #FFFFFF;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 10px 10px 10px 10px;
            box-sizing: border-box;
            padding: 15px 10px;
            position: relative;
            // display: flex;
            align-items: center;
            margin-right: 30px;
            cursor: pointer;

            .cli_icon {
                width: 20px;
                height: 20px;
                position: absolute;
                right: 0;
                top: 0;
            }

            .cli_left {
                width: 36px;
                height: 36px;
                border-radius: 6px;

            }

            .cli_right {
                flex: 1;
                margin-left: 8px;

                .lir_top {
                    width: 100%;
                    font-weight: 500;
                    font-size: 14px;
                    color: #000000;
                    // margin-bottom: 8px;
                }

                .lir_bottom {
                    display: flex;
                    align-items: center;
                    font-weight: 500;
                    font-size: 12px;
                    color: #999999;

                    img {
                        width: 32px;
                        height: 16px;
                        margin-right: 8px;
                    }
                }
            }
        }

        .cll1 {
            // filter: blur(0) !important;

        }

        .cll {
            color: #1096F1 !important;
        }

        .tooltip {
            position: relative;
            background-color: #fff;
            border: 1px solid #ccc;
            border-radius: 8px;
            padding: 10px 15px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            font-size: 14px;
            color: #333;
            margin-bottom: 10px;
            /* 为引导线留出空间 */
        }

        .cl_label::after {
            content: '';
            position: absolute;
            top: 100%;
            /* 在气泡下方 */
            left: 50%;
            /* 水平居中 */
            margin-left: -5px;
            /* 调整位置 */
            border-width: 5px;
            /* 引导线的大小 */
            border-style: solid;
            border-color: #fff transparent transparent transparent;
            /* 下边框为白色，其他为透明 */
        }

        .cl_label::before {
            content: '';
            position: absolute;
            top: 100%;
            /* 在气泡下方 */
            left: 50%;
            /* 水平居中 */
            margin-left: -6px;
            /* 调整位置 */
            border-width: 6px;
            /* 引导线的大小 */
            border-style: solid;
            border-color: #ccc transparent transparent transparent;
            /* 下边框为灰色，其他为透明 */
            z-index: -1;
            /* 使背景引导线在气泡后面 */
        }

        .cl_label {
            width: 140px;
            height: 80px;
            background: #FFFFFF;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 10px 10px 10px 10px;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-right: 30px;
            cursor: pointer;
            box-sizing: border-box;
            padding: 0 10px;
            // opacity: .5;
            // filter: blur(5px);
            // background: rgba(255, 255, 255, 0.5); /* 半透明背景 */
            // backdrop-filter: blur(10px); /* 背景虚化 */

            .switch {
                position: absolute;
                right: 10px;
                top: 10px;
                width: 15px;
                height: 15px;
                cursor: pointer;
                // background: #000;
            }

            img {
                width: 36px;
                height: 36px;
                border-radius: 6px;
            }

            .cll_tit {
                width: 100%;
                text-align: center;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                margin-top: 8px;
            }

            .cll_line {
                width: 60px;
                height: 4px;
                background: #1096F1;
                border-radius: 2px 2px 2px 2px;
                position: absolute;
                bottom: 0;
            }
        }
    }

    .c_right1 {
        width: 128px;
        height: 36px;
        background: #FF4B4B;
        border-radius: 8px 8px 8px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 800;
        font-size: 16px;
        color: #FFFFFF;
        cursor: pointer;

        img {
            width: 15px;
            height: 16px;
            margin-right: 10px;
        }
    }

    .c_right {
        width: 128px;
        height: 36px;
        background: #399AFF;
        border-radius: 8px 8px 8px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 800;
        font-size: 16px;
        color: #FFFFFF;
        cursor: pointer;

        img {
            width: 14px;
            height: 16px;
            margin-right: 10px;
        }
    }
}

.bottom {
    width: 100%;
    height: 0;
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;

    .b_left::-webkit-scrollbar {
        display: none;
    }

    .b_left {
        width: 800px;
        height: 100%;
        overflow-y: scroll;
        display: flex;
        align-items: center;
        align-content: flex-start;
        flex-wrap: wrap;
        border-radius: 30px 30px 30px 30px;
        border: 1px solid #EDEDED;
        box-sizing: border-box;
        padding: 20px 0;

        .bl_item {
            width: 130px;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            margin-bottom: 20px;
            cursor: pointer;
            position: relative;

            .pause {
                width: 32px;
                height: 16px;
                margin-top: 5px;
            }

            .b1 {
                border: 3px solid #5DDB85;
            }

            .border {
                width: 26px;
                height: 26px;
                position: absolute;
                bottom: 15px;
                right: 20px;
                border: 0;
            }

            .blil {
                color: #ff2929 !important;
                border: 1px solid #ff2929 !important;
            }

            .bli_label {
                width: fit-content;
                background: #FFFFFF;
                border-radius: 2px;
                border: 1px solid #27C189;
                font-weight: 500;
                font-size: 12px;
                color: #27C189;
                position: absolute;
                bottom: 60px;
                box-sizing: border-box;
                padding: 2px 5px;
            }

            img {
                width: 60px;
                height: 60px;
                border-radius: 6px;
                margin-bottom: 15px;
                box-sizing: border-box;
            }
        }
    }

    .b_right::-webkit-scrollbar {
        display: none;
    }

    .b_right {
        width: 380px;
        height: 100%;
        border: 1px solid #EDEDED;
        border-radius: 30px 30px 30px 30px;
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        overflow-y: scroll;

        .br_tit {
            width: 100%;
            box-sizing: border-box;
            padding: 20px;
            font-weight: bold;
            font-size: 20px;
            color: #000000;
            display: flex;
            align-items: center;
            position: relative;

            .brt_tj {
                position: absolute;
                right: 10px;
                width: 84px;
                height: 36px;
                background: #399AFF;
                border-radius: 8px 8px 8px 8px;
                font-size: 16px;
                color: #FFFFFF;
                text-align: center;
                line-height: 36px;
                user-select: none;
                cursor: pointer;
            }

            .brt_left {}

            .brt_right {
                flex: 1;
                margin-right: 80px;
            }
        }

        .br_box {
            // flex: 1;
            height: 280px;
            width: 100%;
        }

        .br_bottom {
            width: 100%;
            box-sizing: border-box;
            padding: 20px;

            .brb_btn {
                width: 100%;
                height: 40px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                border: 1px solid #399AFF;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 500;
                font-size: 16px;
                color: #399AFF;
                user-select: none;
                cursor: pointer;
                margin-top: 15px;

            }

            .brb_top {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
            }

            .brb_bottom {
                width: 100%;
                // height: 50%;
                // overflow-y: scroll;
                font-weight: 500;
                font-size: 14px;
                color: #666666;
                line-height: 28px;
                margin-top: 15px;
                // white-space: pre-wrap;
                // word-break: break-all;
                // display: -webkit-box;
                // overflow: hidden;
                // text-overflow: ellipsis;
                // -webkit-line-clamp: 5;
                // -webkit-box-orient: vertical;
            }
        }
    }
}

// }
// }</style>
